import MeaPage from "../../../components/MeaPage";
import { useRef, useState } from "react";
import StudentsListComponent from "./components/StudentsListComponent";
import { useParams } from "react-router-dom";

const StudentsListPage = () => {
  //
  const params = useParams();
  const schoolId = params.schoolId;
  const trainingId = params.trainingId;
  const listRef = useRef();
  const [showPassingColumns, setShowPassingColumns] = useState(false);
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Liste des élèves inscrits"
        subtitle="Gérer l'ensemble des élèves avec inscription validée de cette formation"
        actions={[
          {
            label: showPassingColumns
              ? "Masquer les avis de passage"
              : "Afficher les avis de passage",
            icon: showPassingColumns ? "pi pi-eye-slash" : "pi pi-eye",
            command: () => {
              setShowPassingColumns((currentValue) => !currentValue);
            },
          },
        ]}
      >
        <StudentsListComponent
          ref={listRef}
          schoolId={schoolId}
          trainingId={trainingId}
          showExportButton={true}
          showFilter={true}
          showFilterButton={true}
          showSlotChangeColumn={false}
          familyColumnLabel="Fichier élève"
          familyColumnIcon="pi pi-file"
          familyColumnTooltip="Voir le dossier élève"
          selectedFields={{
            passing: showPassingColumns,
            observation: showPassingColumns,
          }}
        />
      </MeaPage>
    </>
  );
};
export default StudentsListPage;
